import { CAR_SEARCH_FETCHED, SEARCHING_CARS } from '../../actions/car';

import { api2form } from '../../Search/car/helpers/mapSearchParams';

export default function searchParamsBySearchId(state = {}, action) {
  const newState = Object.assign({}, state);

  switch (action.type) {
    case SEARCHING_CARS:
      newState.lastSearch = action.params;
      return newState;

    case CAR_SEARCH_FETCHED:
      newState[action.searchId] = api2form(action.searchParams);
      newState.lastSearch = api2form(action.searchParams);

      return newState;

    default:
      return state;
  }
}
